import React from 'react';

import {
  EditSbatGroupLessonForm,
  CONTEST_LESSON_INPUT_OPTIONS,
  findLessonByLessonType,
  LESSON_TYPES,
} from 'features/classCreation';
import EditableSection from 'components/EditableSection';
import Field from 'components/Field';

function ContestRequirements({ sbatGroup }) {
  const lessons = sbatGroup?.academy_topic?.lessons;
  const contestLesson = findLessonByLessonType({
    lessons,
    lessonType: LESSON_TYPES.contest,
  });
  const { meta } = contestLesson || {};
  const { is_group_contest: isGroupContest } = meta || {};

  return (
    <Field
      label="Contest Requirements"
      labelClassName="m-b-xs"
    >
      {lessons.map((lesson) => {
        const label = CONTEST_LESSON_INPUT_OPTIONS[lesson.lesson_type]?.label;

        return (
          <div key={lesson.id}>
            {label && (
              <EditableSection
                canEdit={!isGroupContest}
                title={label}
                titleClassName="hint"
                className="m-b-s"
                key={lesson.id}
              >
                {(editableProps) => (
                  <EditSbatGroupLessonForm
                    {...editableProps}
                    sbatGroup={sbatGroup}
                    value={lesson}
                    label={label}
                  />
                )}
              </EditableSection>
            )}
          </div>
        );
      })}
    </Field>
  );
}

export default ContestRequirements;
